import { Theme } from "@emotion/react";

import { SignalDoc, SignalLevel } from "@megaron/docs-contracts";

import { navAccent } from "../nav/navConstants";

export const signalLevelRank: Record<SignalLevel, number> = { info: 0, warning: 1, error: 2 };

export const topSignalLevel = (signals: SignalDoc[]): SignalLevel =>
  signals.reduce<SignalLevel>(
    (top, signal) => (signalLevelRank[signal.level] > signalLevelRank[top] ? signal.level : top),
    "info",
  );

export const signalColor = (level: SignalLevel, theme: Theme): string => {
  if (level === "error") return theme.colors.danger;
  if (level === "warning") return theme.colors.warning;
  return navAccent;
};

export const signalLevelLabel: Record<SignalLevel, string> = {
  info: "info",
  warning: "Ostrzeżenie",
  error: "Błąd",
};
